import styled from 'styled-components'
import { themeContract } from './CreditOptionsBanner.theme.contract'

const BannerHeading = styled.div`
  position: relative;
  display: block;
  padding: 17px 20px 17px 20px;
  border: 1px solid ${props => props.theme.color.palette['brand-1']};
  border-radius: 3px 3px 0 0;
  font-size: 22px;
  line-height: 22px;
  letter-spacing: 0.03px;
  text-align: center;

  > p {
    font-weight: 600;
    margin: 0;
  }
`

const InterestRate = styled.div`
  border-radius: 0px 0px 3px 3px;
  border: 1px solid ${props => props.theme.color.palette[themeContract[props.theme.channel].apr.border]};
  background-color: ${props => props.theme.color.palette[themeContract[props.theme.channel].apr.background]};
  color: ${props => props.theme.color.palette[themeContract[props.theme.channel].apr.color]};
  text-align: center;

  > p {
    margin: 0;
    line-height: 36px;
  }

  .interest {
    font-size: 22px;
  }
`

const BottomLabel = styled.div`
  color: ${props => props.theme.color.monochrome.dark};
  text-align: center;
  padding-top: 10px;
`

export { BannerHeading, InterestRate, BottomLabel }
